import React, { useEffect, ReactNode } from 'react';
import { initializeApp } from 'firebase/app';
import { endpoints } from '../config';

const firebaseEndpointsConfig = endpoints?.firebase_config;

const firebaseConfig = {
  apiKey: firebaseEndpointsConfig?.apiKey,
  authDomain: firebaseEndpointsConfig?.authDomain,
  databaseURL: firebaseEndpointsConfig?.databaseURL,
  projectId: firebaseEndpointsConfig?.projectId,
  storageBucket: firebaseEndpointsConfig?.storageBucket,
  messagingSenderId: firebaseEndpointsConfig?.messagingSenderId,
  appId: firebaseEndpointsConfig?.appId,
};

interface NotificationProviderProps {
  children: ReactNode;
}

const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  useEffect(() => {
    if (firebaseConfig.apiKey) {
      initializeApp(firebaseConfig);
    }
  }, []);

  return <>{children}</>;
};

export default NotificationProvider;

